import { useEffect } from "react";
import BibliographyPageText from "../components/BibliographyPageText";

function Bibliography(props) {
    useEffect(() => {
        props.funcNav(true);
        window.scrollTo(0, 0);
    }, [props]);


    return (
        <main>
            <BibliographyPageText />
        </main >
    )

}
export default Bibliography;